import React, { Component } from "react";
import { connect } from "react-redux";
import { parseString } from "xml2js";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import api from "../../api";
import {
  addItemToProgress,
  removeItemFromProgress,
} from "../../actions/progressList";
import NeighborSubjectDetail from "./NeighborSubjectDetail";

class NeighborsReportSection extends Component {
  state = {
    addresses: [],
    activeIndex: 0,
    neighborDetails: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadSection = (node, props) => {
    const addresses = _.get(
      node,
      "personReport.neighbors[0].subject[0].addresses[0].address"
    );
    const neighborDetails = [];
    let neighborsCount = 0;
    if (addresses !== undefined && addresses.length > 0) {
      let updatedAddresses = [];
      _.forEach(addresses, (address) => {
        const dateFrom = _.get(address, "dateFrom[0]._");
        if (dateFrom !== undefined) {
          const tokens = dateFrom.split("/");
          if (tokens.length > 1) {
            address.dateFromRaw = `${tokens[1]}${tokens[0]}`;
          }
        }
        const dateTo = _.get(address, "dateTo[0]._");
        if (dateTo !== undefined) {
          const tokens = dateTo.split("/");
          if (tokens.length > 1) {
            address.dateToRaw = `${tokens[1]}${tokens[0]}`;
          }
        }
        updatedAddresses.push(address);
      });
      updatedAddresses = _.orderBy(
        updatedAddresses,
        ["dateToRaw", "dateFromRaw"],
        ["desc", "desc"]
      );
      _.forEach(updatedAddresses, (neighborsAddressNode, index) => {
        const persons = _.get(neighborsAddressNode, "neighbours[0].person");
        if (persons !== undefined) {
          neighborsCount += persons.length;
          neighborDetails.push(
            <NeighborSubjectDetail
              key={`Neighbor_res_detail_${index}`}
              {...this.props}
              neighborsAddressNode={neighborsAddressNode}
            />
          );
        }
      });
    }
    if (neighborsCount === 0) {
      neighborDetails.push(
        <Table key={`no_recs_table`}>
          <Table.Body>
            <Table.Row key={`no_recs_row`}>
              <Table.Cell colSpan={100}>No Records found</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }
    props.updateItemCountBySection(props.sectionName, neighborsCount);
    props.removeItemFromProgress({ name: "neighbors" });
    this.setState({ neighborDetails });
  };

  loadData = (props) => {
    const sectionNode = _.get(props.reportData, "personReport.neighbors[0]");
    if (sectionNode) {
      this.loadSection(props.reportData, props);
    } else {
      const additionalData = _.cloneDeep(props.additionalData);
      additionalData.requestedSection = "neighbors";
      props.addItemToProgress({ name: "neighbors" });
      api.report
        .person(additionalData, props.cancelToken)
        .then((res) => {
          parseString(res.data, { async: true }, (err, rslt) => {
            this.loadSection(rslt, props);
          });
        })
        .catch((err) => {
          console.log("neighbors res error - ", err);
          props.removeItemFromProgress({ name: "neighbors" });
        });
    }
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Accordion fluid styled id={`nav_${this.props.sectionName}`}>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`NeighborTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            Current Neighbors
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`NeighborBody`}
          active={this.state.activeIndex === 0}
        >
          {this.state.neighborDetails !== null && this.state.neighborDetails}
        </Accordion.Content>
      </Accordion>
    );
  }
}

function mapStateToProps(state) {
  return {
    cancelToken: state.apiCancelSource
      ? state.apiCancelSource.token
      : undefined,
  };
}

export default connect(mapStateToProps, {
  addItemToProgress,
  removeItemFromProgress,
})(NeighborsReportSection);



// WEBPACK FOOTER //
// ./src/components/reports/NeighborsReportSection.js